import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const productSecurityPlugin = createPlugin({
  id: 'product-security',
  routes: {
    root: rootRouteRef,
  },
});

export const ProductSecurityPage = productSecurityPlugin.provide(
  createRoutableExtension({
    name: 'ProductSecurityPage',
    component: () =>
      import('./components/Product-Security').then(m => m.default),
    mountPoint: rootRouteRef,
  }),
);
